export default __webpack_public_path__ + "static/media/2.b09b3652.jpg";